// extracted by mini-css-extract-plugin
export default {"container":"recordings_container__zGS21","select":"recordings_select__hpD6S","footer":"recordings_footer__Sz4hL"};